<template>
	<section class="detailLayout mainLayout">
		<div class="detailGroup">
			<videoplayer 
				:videoID="$route.params.videoID" 
				previewType="video"
			></videoplayer>
		</div>
		<social-sharing 
			:url="detailUrl" 
			v-if="detailUrl"
			title="Vota per questo rutto su garadirutti.tk!"
			description="Vota per questo #rutto per farlo salire in calssifica su www.garadirutti.tk"
			quote="Vota per questo video per farlo salire in classifica!"
			hashtags="rutto,gara,classifica,burp"
			inline-template
		>
			<div class="detailGroup shareMe">
				<span class="textBase">
					Condividi il video per votare sui social
				</span>

				<network 
					network="facebook" 
					v-if="!shareAPI"
				>
					<i class="gdr-icon gdr-icon-facebook"></i>
				</network>
				<!--
				<network network="googleplus" v-if="!shareAPI">
					<i class="gdr-icon gdr-icon-google-plus"></i>
				</network>
				-->
				<network 
					network="twitter" 
					v-if="!shareAPI"
				>
					<i class="gdr-icon gdr-icon-twitter"></i>
				</network>

				<button class="webShareAPI" 
					v-if="shareAPI"
					@click="shareTo"
				>
					Condividi
				</button>
			</div>
		</social-sharing>
	</section>
</template>
<script>
	export default {
		name: 'detailLayout',
		data () {
			return {
				videos: []
			}
		},
		computed:{
			online: function(){
				if(navigator.onLine){
					return true
				}else{
					return false
				}
			},
			detailUrl: function(){
				return window.location.href;
			},
			shareAPI: function(){
				if (window && window.navigator && window.navigator.share) {
					return true;
				}else{
					return false;
				}
			}
		},
		methods:{
			shareTo: function(){
				navigator.share({
					title: 'Vota per questo rutto su garadirutti.tk!',
					text: 'Vota per questo #rutto per farlo salire in calssifica su www.garadirutti.tk',
					url: this.detailUrl
				})
				.then(() => console.log('Successful share'))
				.catch((error) => console.log('Error sharing', error))
			}
		},
		components:{
			videoplayer: () => import('./videoPlayer')
		},
		created: function(){
			/*
			if(!navigator.onLine){
				this.$router.go(-1);
				return;
			}
			*/

		},
		beforeDestroy: function(){
			if((this.$root)&&(this.$root.closeMenu)){
				this.$root.closeMenu()
			}
		}
	}
</script>
<style lang="less">
	.detailLayout{
		height:100vh;
		overflow-y: scroll;
		box-sizing: border-box;
		width:100%;
		.detailGroup{
			display: block;
			max-width:800px;
			margin:auto;
		}
		.shareMe{
			// background-color: white;
			
			box-sizing: border-box;
			
			margin-bottom: 100px;
			text-align:right;
			&>span,
			&.webShareAPI{
				background-color: white;
				display:inline-block;
				cursor:pointer;
				padding-left:20px;
				padding-right: 20px;
				margin-left: 15px;
				box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);
				line-height: 46px;
				margin-bottom: 15px;
				border:none;
				&.textBase{
					cursor:default;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// detailLayout.vue?073de5e8